<template xmlns="http://www.w3.org/1999/html">
  <div>
    <!-- 顶部欢迎及注册登录按钮导航 -->
    <header-top />
    <!-- 顶部公司logo及导航栏 -->
    <div style="width:100%;height:100px;">
      <div class="logoNav">
        <!-- 左侧logo -->
        <img src="../../assets/img/logo.gif" width="200" style="margin-top:30px;">

        <!-- 右侧小图标 -->
        <img src="../../assets/img/home/head-bg.png" style="position: absolute;right: 0;bottom: 0;" width="450">
        <!-- <img src="../../assets/img/home/homelogoHeadRight.png"> -->
      </div>
    </div>
    <!-- 导航栏 -->
    <nav-head></nav-head>
    <!--查询专利分页内容-->
    <div class="zlQueryList">
      <div class="zlQueryListContent"  v-for="(item, index) in collectionList" style="margin-bottom: 5px">
        <el-row :gutter="20">
          <el-col :span="4">
            <div class="ThumbDiv">
              <el-image :src="item.thumbnail" style="width: 170px;height: 170px; "></el-image>
            </div>
          </el-col>
          <el-col :span="19">
            <el-row>
              <h3 class="zlName" @click="goZlDetail(item.id)">{{item.name}}-{{item.applicationNumber}};{{item.openNumber}}</h3>
            </el-row>
            <el-row>
              <h4 class="zlName2">{{item.foreignName}}</h4>
            </el-row>
            <el-row>
              <h4 class="zlName2" style="color: #1e7e34">申请人：{{item.applicant}} - 申请日：{{item.applicantDate}} - 公开日：{{item.openDate}} - 分类号：{{item.ipcMainClassify}}</h4>
            </el-row>
            <!--摘要-->
            <el-row>
              <span class="zy">{{item.absrtact}}</span>
            </el-row>
            <el-row style="margin-top: 5px;">
              <el-image v-show="item.isCollect === 0" :src="wsc" style="width: 30px; height: 30px" @click="addDialogVisible = true;addCollectionFrom.patentId = item.id"></el-image>
<!--                            <el-image v-show="item.isCollect !== 0" :src="ysc" style="width: 30px; height: 30px"></el-image>-->
              <el-popconfirm title="确定要取消收藏吗？" @confirm="cancelUserCollectionPatent(collectionId,item.id)">?">
                <template #reference>
                  <el-image v-show="item.isCollect !== 0" :src="ysc" style="width: 30px; height: 30px"></el-image>
                </template>
              </el-popconfirm>
            </el-row>
          </el-col>
        </el-row>
      </div>
    </div>
  </div>
</template>
<script>
import wsc from "@/assets/img/zlicons/wsc.png"
import ysc from "@/assets/img/zlicons/ysc.png"
import HeaderTop from "@/components/headerTop/headerTop.vue";
import NavHead from "@/components/navHead/navHead.vue";

export default {
  name: "zlByCollection",
  components: {HeaderTop, NavHead},
  data() {
    return {
      wsc,
      ysc,
      collectionId: '',
      collectionList: []
    }
  },
  mounted() {
    let queryFrom;
    queryFrom = JSON.parse(this.$route.params.collectionId)
    this.collectionId = queryFrom.id
    console.log(this.collectionId)
    this.getZlList()
  },
  methods: {
    // 查询收藏夹下的专利列表
    getZlList() {
      this.axios.get('/api/userCollectionPatent/findUserCollectionPatentList?collectionId='+this.collectionId).then(res => {
        this.collectionList = res.data.data
        console.log(this.collectionList)
      })
    },
    goZlDetail(id) {
      var from = {id: id}
      this.$router.push({
        name: 'zlDetail',
        params: {
          queryId: JSON.stringify(from)
        }
      })
    },
    //取消收藏
    cancelUserCollectionPatent(collectionId, patentId) {
      this.axios.get('/api/userCollectionPatent/cancelUserCollectionPatent?collectionId='+collectionId+'&patentId='+patentId).then(res => {
        if (res.data.code === 10001) {
          this.$message({
            message: '取消收藏成功',
            type: 'success'
          })
          this.getZlList()
        } else {
          this.$message({
            message: '取消收藏失败',
            type:'error'
          })
        }
      })
    },
  }
}
</script>
<style scoped>
/* logo及导航栏 */
.logoNav {
  width: 1200px;
  height: 100px;
  margin: 0 auto;
  position: relative;
  bottom: 8px;
}

.zlQueryList {
  background-color: rgba(216, 217, 220, 0.92);
  margin: 0px auto;
  width: 100%;
  height: 100%;
  padding-top: 5px;
  padding-bottom: 2px;
}

.zlQueryListContent {
  width: 95%;
  background-color: #fff;
  margin: 0px auto;
  padding-top: 10px;
  padding-bottom: 10px;
  padding-left: 50px;
}

.ThumbDiv {
  border: 1px solid rgb(187,187,187);
  text-align: center;
}
.zlName {
  font-size: 16px;
  font-weight: normal;
  color: #00c;
  text-decoration: underline;
}
.zlName:hover {
  cursor: pointer;
}
.zlName2 {
  font-size: 12px;
  font-weight: normal;
  color: #00c;
}
.zy {
  font-size: 14px;
  font-weight: normal;
  color: #000000;
}
</style>
